var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page__content customer-account"},[_c('div',{staticClass:"shine"}),_c('AppHeader'),_c('AccountMenu')],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }